export default "__VITE_ASSET__DZclMie___"